export default __webpack_public_path__ + "static/media/DevConnect-removebg-preview.a580fb46.png";